import * as React from "react";
import * as Moment from "moment-timezone";
import * as Utils from "../Utils";
import DoomsdayDays, { IDaysState } from "./DoomsdayDays";
import DoomsdayExercise from "./DoomsdayExercise";
import DoomsdayStat from "./DoomsdayStat";

export interface IGameStatItem {
  solution: Moment.Moment;
  success: boolean;
  answerTimeMs: number;
}

export interface IDoomsdayGameProps {
  onEnd: () => void;
}

export interface IDoomsdayGameState {
  currentDate: Moment.Moment;
  ended: boolean;
  startedMs: number;
  stat: IGameStatItem[];
  days: IDaysState;
}

const MAX_COUNT = 20;

export default class DoomsdayGame extends React.Component<
  IDoomsdayGameProps,
  IDoomsdayGameState
> {
  constructor(props: IDoomsdayGameProps) {
    super(props);
    this.state = {
      currentDate: this.randomDate(),
      days: {},
      ended: false,
      startedMs: Utils.getNowLocal(),
      stat: [],
    };
    this.tip = this.tip.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.addToStat = this.addToStat.bind(this);
  }

  public render() {
    return (
      <>
        {this.state.ended ? (
          <DoomsdayStat stat={this.state.stat} onEnd={this.props.onEnd} />
        ) : (
          <>
            <DoomsdayExercise
              count={this.state.stat.length}
              currentDate={this.state.currentDate}
              points={this.state.stat.filter((s) => s.success).length}
            />
            <DoomsdayDays tip={this.tip} days={this.state.days} />
          </>
        )}
      </>
    );
  }

  public componentDidMount() {
    document.body.addEventListener("keydown", this.onKeydown);
  }

  public componentWillUnmount() {
    document.body.removeEventListener("keydown", this.onKeydown);
  }

  private tip(day: number) {
    if (this.state.ended || this.state.days[day] !== undefined) {
      return;
    }
    const currentDay = this.state.currentDate.day();
    const firstTip = Object.keys(this.state.days).length === 0;
    const newState: Partial<IDoomsdayGameState> = {};
    if (currentDay === day) {
      if (firstTip) {
        newState.stat = this.addToStat(1);
      } else {
        newState.stat = this.addToStat(0);
      }
      newState.currentDate = this.randomDate();
      newState.ended = newState.stat.length === MAX_COUNT;
      newState.startedMs = Utils.getNowLocal();
      newState.days = {};
    } else {
      newState.days = {...this.state.days, [day]: false};
    }
    this.setState({ ...this.state, ...newState });
  }

  private randomDate() {
    const year = this.getRandomInt(1900, 2050);
    const moment = Moment().year(year);
    if (moment.isLeapYear()) {
      return moment.dayOfYear(this.getRandomInt(1, 367));
    } else {
      return moment.dayOfYear(this.getRandomInt(1, 366));
    }
  }

  // The maximum is exclusive and the minimum is inclusive
  private getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  private onKeydown(event: KeyboardEvent) {
    if (!event.key) {
      return;
    }
    const num = parseInt(event.key, 10);
    if (num >= 0 && num <= 9) {
      this.tip(num);
    }
  }

  private addToStat(point: number) {
    return [
      ...this.state.stat,
      {
        answerTimeMs: Utils.getNowLocal() - this.state.startedMs,
        solution: this.state.currentDate,
        success: point > 0,
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayGame.tsx